"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var ALLOWED_PROPS = ["size", "color", "customColor", "className", "dataTest", "ariaHidden", "reverseOnRtl", "ariaLabel", "dataTest"];

var whiteListProps = function whiteListProps(props) {
  return (// $FlowExpectedError
    Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(ALLOWED_PROPS.map(function (k) {
      return k in props ? (0, _defineProperty2.default)({}, k, props[k]) : {};
    }))))
  );
};

var _default = whiteListProps;
exports.default = _default;